import {SessionService} from './session.service';

/** Permissions vérifiées sur n'importe quel restaurant (pas le restaurant courant). */
const GLOBAL_PAGE_PERMISSIONS = new Set([
	'reservation_event_national',
	'reservation_event_review',
	'equipements_national',
	'devis_catalog_national',
	'edit_ticket',
	'recrutement_moderate',
	'create_restaurant',
	'support',
]);

export function isGlobalPagePermission(permission: string): boolean {
	return GLOBAL_PAGE_PERMISSIONS.has(permission);
}

export function hasPagePermission(session: SessionService, permission: string): boolean {
	if (isGlobalPagePermission(permission)) {
		return session.hasPermission(permission);
	}
	const restaurantId = session.getRestaurantId();
	if (!restaurantId) {
		return session.hasPermission(permission);
	}
	return session.hasPermission(permission, restaurantId);
}

export function hasAnyPagePermission(session: SessionService, permissions: string[]): boolean {
	return permissions.some((permission) => hasPagePermission(session, permission));
}

export function isDashboardHomeUrl(url: string): boolean {
	const path = url.split('?')[0].replace(/\/+$/, '') || '/';
	return path === '/pages/dashboard';
}
